export const environment = {
  production: true,
  apiServer: '/api/',
  urlServer: 'https://api-dev.globalsyndicatepricer.us.mizuho-sc.com/',
};
